import classNames from 'classnames';
import React, { FC, ReactElement } from 'react';
import LoadingSpinner from 'src/common/components/loading-spinner';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { SmallPanel } from 'src/common/ui/small-panel';

export interface EditorConfirmPanelProps
  extends Pick<JourneyMenuPropsInterface, 'openRef' | 'closeRef' | 'placement' | 'offset' | 'renderOrigin'> {
  copy: string | ReactElement;
  confirmCopy?: string;
  denyCopy?: string;
  isConfirmLoading?: boolean;
  onConfirm?: () => void;
  onDeny?: () => void;
  onBack?: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  hasBackButton?: boolean;
  containerClassName?: string;
  originClassName?: string;
  confirmButtonClassName?: string;
  disableConfirmButton?: boolean;
  disableDenyButton?: boolean;
  openAfterMount?: boolean;
  fixed?: boolean;
}

export const EditorConfirmPanel: FC<EditorConfirmPanelProps> = ({
  renderOrigin,
  openRef,
  closeRef,
  offset,
  placement,
  copy,
  confirmCopy = 'Yes, delete',
  denyCopy = 'No, keep',
  onConfirm,
  onDeny,
  onBack,
  onOpen,
  onClose,
  hasBackButton = true,
  openAfterMount = true,
  containerClassName,
  isConfirmLoading,
  originClassName,
  confirmButtonClassName,
  disableConfirmButton,
  disableDenyButton,
  fixed = true,
}) => {
  return (
    <SmallPanel
      placement={placement}
      offset={offset}
      containerClassName={containerClassName}
      originClassName={originClassName}
      openAfterMount={openAfterMount}
      fixed={fixed}
      hasBackButton={hasBackButton}
      openRef={openRef}
      closeRef={closeRef}
      onBack={onBack}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={renderOrigin}
    >
      <div className='flex flex-col space-y-md'>
        <div className='text-bedrock-p text-bedrock-black cursor-default'>{copy}</div>
        <div className='flex items-center space-x-2'>
          <button
            type='button'
            className={classNames('disabled:cursor-not-allowed', confirmButtonClassName || 'btn-bedrock-red')}
            onClick={onConfirm}
            disabled={disableConfirmButton}
          >
            {isConfirmLoading ? <LoadingSpinner /> : confirmCopy}
          </button>
          <button type='button' className='btn-bedrock-secondary' disabled={disableDenyButton} onClick={onDeny}>
            {denyCopy}
          </button>
        </div>
      </div>
    </SmallPanel>
  );
};
